import { Skeleton } from "@/components/ui/skeleton";
import { 
  Sidebar, 
  SidebarContent, 
  SidebarHeader, 
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

/**
 * Loading skeleton for sidebar while auth context loads.
 * Prevents flicker by showing consistent layout without role-specific items.
 */
export function SidebarSkeleton() {
  return (
    <Sidebar className="border-r border-sidebar-border" collapsible="icon">
      <SidebarHeader className="p-4 border-b border-sidebar-border">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-3 w-20 mt-1" />
      </SidebarHeader>
      
      <SidebarContent>
        <SidebarGroup>
          <Skeleton className="h-4 w-16 ml-2 mb-2" />
          <SidebarGroupContent>
            <SidebarMenu>
              {[1, 2, 3, 4].map((i) => (
                <SidebarMenuItem key={i}>
                  <div className="flex items-center gap-2 px-3 py-2">
                    <Skeleton className="h-4 w-4" />
                    <Skeleton className="h-4 w-24" />
                  </div>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      
      <SidebarFooter className="p-4 border-t border-sidebar-border">
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="flex-1">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-3 w-32 mt-1" />
          </div>
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
